module.exports = __webpack_public_path__ + "static/media/mail.34d3b40e.svg";